import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { BehaviorSubject, Observable } from "rxjs";
import { map } from 'rxjs/operators';
import * as azure from 'azure-storage';
import { SettingsProvider, Settings, Product, Table, ProductOption } from '../settings/settings';

/*
  Generated class for the OrdersProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class OrdersProvider {

  private settings: Settings;

  private orders$: BehaviorSubject<Order[]> = new BehaviorSubject<Order[]>([]);

  public all$: Observable<Order[]> = this.orders$.asObservable();

  constructor(private storage: Storage, private settingsProvider: SettingsProvider) {
    this.settingsProvider.settings$.subscribe(settings => {
      this.settings = settings;
    })

    this.storage.ready().then(_ => {
      this.storage.get('orders').then(orders => {
        if (orders) {
          orders = this.orders$.value.concat(orders);
          this.orders$.next(orders);
          this.storage.set('orders', orders);
        }

        this.orders$.subscribe(orders => {
          this.storage.set('orders', orders);
        });
      });
    });
  }

  getById(id: string): Observable<Order> {
    return this.orders$.pipe(
      map(orders => orders.find(order => order.id == id))
    );
  }

  send(order: Order) {
    var queueService = azure.createQueueService('DefaultEndpointsProtocol=https;AccountName=orderking;AccountKey=Dts4gvQ91o8OD1SMMB8t5zLumgfmOirNyvQIPmB3/wdEZ5wnp1apYz4HvxobVm5Jq/A0ZaLGVxJ7aJgJddQOGw==;EndpointSuffix=core.windows.net');
    queueService.messageEncoder = new azure.QueueMessageEncoder.TextBase64QueueMessageEncoder;
    queueService.createMessage('printer', JSON.stringify({
      id: order.id,
      by: this.settings && this.settings.name ? this.settings.name : 'Onbekend',
      table: order.table ? order.table.name : 'Onbekend',
      comments: order.comments,
      ordered: order.ordered,
      products: order.products.map(p => {
        return {
          id: p.product.id + (p.options && p.options.length > 0 ? '-' + p.options.map(o => o.id).join('-').replace(' ', '-').toLowerCase() : ''),
          name: p.product.name + (p.options && p.options.length > 0 ? ' ' + p.options.map(o => o.name).join(' ').toLowerCase() : '')
        };
      })
    }), function (error) {
      console.log(error);
    });

    order.sent = true;
  }

  // getById(id: string) {
  //   // return Observable.of(this._order.find((value: Order, index: number, obj: Order[]) => {
  //   //   return value.id == id;
  //   // }));
  // }

  // orderProduct(product: Product) {
  //   this.orders$.pipe(

  //   )
  //   this._order.push({
  //     id: this.newId(),
  //     products: []
  //   });
  //   this._currentOrder.next(this._order);
  // }

  createOrder(): string {
    var orders = this.orders$.value;

    var order = {
      id: this.newId(),
      table: null,
      ordered: new Date(),
      products: [],
      sent: false,
      comments: null
    };

    orders.push(order);

    this.orders$.next(orders);

    return order.id;
  }

  setTable(orderId: string, table: Table) {
    var orders = this.orders$.value;

    var order = orders.find(order => order.id == orderId);
    if (order == undefined) {
      order = {
        id: orderId,
        table: null,
        ordered: new Date(),
        products: [],
        sent: false,
        comments: null
      };

      orders.push(order);
    }

    order.table = table;
  }

  removeOrder(orderId: string) {
    var orders = this.orders$.value;

    var orderIndex = orders.findIndex(order => order.id == orderId);
    if (orderIndex >= 0) {
      orders.splice(orderIndex, 1);
    }

    this.orders$.next(orders);
  }

  addProduct(orderId: string, product: Product, options: ProductOption[] = []) {
    var orders = this.orders$.value;

    var order = orders.find(order => order.id == orderId);
    if (order == undefined) {
      order = {
        id: orderId,
        table: null,
        ordered: new Date(),
        products: [],
        sent: false,
        comments: null
      };

      orders.push(order);
    }

    order.products.push({
      id: this.newId(),
      product: product,
      options: options
    });

    this.orders$.next(orders);
  }

  removeProduct(orderId: string, orderProduct: OrderProduct) {
    var orders = this.orders$.value;

    var order = orders.find(order => order.id == orderId);
    if (order) {
      order.products.splice(order.products.findIndex(p => p.id == orderProduct.id), 1);
      this.orders$.next(orders);
    }
  }

  clear() {
    var orders = this.orders$.value;

    this.orders$.next(orders.filter(o => !o.sent));
  }

  newId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

export class Order {
  id: string;
  table: Table;
  ordered: Date;
  products: OrderProduct[];
  sent: boolean = false;
  comments: string;
}

export class OrderProduct {
  id: string;
  product: Product;
  options: ProductOption[];
}



// WEBPACK FOOTER //
// ./src/providers/orders/orders.ts